import {
    SearchPageContainer as SourceSearchPageContainer,
    mapStateToProps,
    mapDispatchToProps
} from 'SourceRoute/SearchPage/SearchPage.container';
import { connect } from 'react-redux';

import { debounce } from 'Util/Request';

import { LOADING_TIME } from 'Route/CategoryPage/CategoryPage.config';

export class SearchPageContainer extends SourceSearchPageContainer {
    config = {
        sortKey: 'position',
        sortDirection: 'ASC'
    };

    componentDidUpdate(prevProps) {
        const {
            isOffline,
            match: { params: { query } },
            currentArgs: {
                filter
            } = {}
        } = this.props;

        const {
            match: { params: { query: prevQuery } },
            currentArgs: {
                filter: prevFilter
            } = {}
        } = prevProps;

        if (isOffline) {
            debounce(this.setOfflineNoticeSize, LOADING_TIME)();
        }

        /**
         * If search query has changed - update related information
         */
        const searchChange = query !== prevQuery;

        if (searchChange) {
            this.updateMeta();
            this.updateBreadcrumbs();
            this.updateHeaderState();
        }

        /**
         * If search wasn't changed we still need to update meta for correct robots meta tag [#928](https://github.com/scandipwa/base-theme/issues/928)
         */
        if (!searchChange
            && filter
            && prevFilter
            && Object.keys(filter.customFilters).length !== Object.keys(prevFilter.customFilters).length
        ) {
            this.updateMeta();
        }
    }

    updateMeta() {
        const { updateMeta } = this.props;

        updateMeta({
            title: __('Search'),
            robots: 'noindex, follow'
        });
    }

    updateBreadcrumbs() {
        const { updateBreadcrumbs } = this.props;
        const search = this.getSearchParam();

        updateBreadcrumbs([
            {
                url: '',
                name: search.toUpperCase()
            }
        ]);
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchPageContainer);
